import { IReducersMap, reducer } from '../../standard-actions/';
import {
    REQUESTS_SUMMARY_LOAD,
    REQUESTS_CATEGORIES_LOAD,
    REQUESTS_CATEGORIES_COUNT,
    REQUEST_CATEGORY_ITEMS_LOAD,
    REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD,
    REQUESTS_OPEN_LOAD,
    REQUESTS_CREATE,
    REQUESTS_CLOSED_LOAD,
    REQUEST_DETAILS_LOAD,
    REQUEST_ACTIVITY_DETAILS_LOAD,
    REQUESTS_FILE_UPLOAD,
    REQUEST_DOMESTIC_ACTIVITIES_LOAD,
    REQUESTS_ADD_COMMENT,
    REQUESTS_CUSTOMER_REFERENCE,
    REQUEST_CATEGORY_WITH_ITEMS_LOAD,
    REQUEST_CATEGORY_WITH_ITEM_QUESTIONS_LOAD,
    REQUEST_CATEGORY_WITH_DEAC_QUESTIONS_LOAD,
    REQUESTS_DEVICES_LOAD,
    REQUESTS_DEVICES_SUMMARY_LOAD,
    REQUESTS_DEVICES_CHARGEABLE_LOAD,
    ENROLL_HISTORY_DATA_LOAD,
    REQUESTS_TENANCY_DETAILS_LOAD,
    REQUESTS_DEVICE_DETAIL_LOAD,
    REQUESTS_USER_DETAIL_LOAD,
    MDM_LOAD_TOPTENAPPS,
    MDM_UPDATE_SEARCH_LOCATIONS,
    MDM_SEARCH_LOCATIONS,
    UPDATE_COVID19_REQUEST_FLAG,
    REQUEST_MOBILE_SERVICES,
    REQUEST_STRATEGIC_DEVICE_DETAILS,
    REQUEST_STRATEGIC_SIM_CONFIG_INFO,
    REQUEST_FEATURE_FLAGS,
    FEATURE_NETWORK_CHANGE_SERVICE_LIST,
    SERVICE_REQUEST_FETCH_USER_PROFILE,
    FEATURE_NETWORK_CHANGE_REQUEST_TYPE_DETAILS,
    NBN_SERVICE_LIST,
    REQUEST_PRODUCT_FAMILIES,
    FEATURE_NETWORK_CHANGE_PRODUCT_CATALOGUE,
    NBN_TESTS_CREATE,
    REQUESTS_ALL_LOAD,
    MAXIM_REQUESTS_ALL_LOAD,
    FEATURE_NETWORK_CHANGE_REQUESTS,
    NBN_TESTS_POLL,
    NBN_UPDATE_TEST_RESULT,
    NBN_UPDATE_DIAGNOSTIC_RESULT,
    NBN_ADD_TOAST,
    NBN_DELETE_TOAST,
    NBN_ADD_RESULT_TOAST,
    NBN_DELETE_RESULT_TOAST,
    NBN_DISMISS_RESULT_TOAST,
    NBN_ADD_ERROR_TOAST,
    NBN_DELETE_ERROR_TOAST,
    VALIDATE_SIM_LOAD,
    NBN_UPDATE_SERVICE_LIST,
    NBN_UPDATE_SERVICE_LIST_PAGINATION,
    FEATURE_NETWORK_CHANGE_FNN_VALIDATION,
    REQUESTS_LOAD_COMPANY,
    NBN_UPDATE_DIAGNOSTIC_ERROR,
    NBN_UPDATE_RESULT,
    NBN_HISTORY_DETAIL,
    DOWNLOAD_FILE_ATTACHMENT,
    LIST_OF_ATTACHMENTS,
    DELETE_FILE_ATTACHMENTS,
    REQUESTS_LOAD_SM_SERVICE_ID,
    MAXIM_REQUEST_DETAILS,
    LOAD_MAXIM_ACTIVITIES, REQUESTS_CUSTOMER_CONTACT_LOAD,
    DELIVERY_ADDRESS_AUTO_SEARCH_LIST,
    ADDRESS_SIMPLIFIED_LIST,
    ADVANCED_ADDRESS_LIST,
    APN_LIST,
    CIDN_ASSOCIATED_SERVICE,
    REQUEST_NIT_SERVICE_FLAG,
    SET_TRACKING_ACTIVE_TAB,
    MOBILE_SERVICES_LIST,
    TON_SUBSCRIPTION_DETAILS_LOAD,
    UPDATE_COMPANY_ID,
    MOBILE_SERVICES_DETAIL_STRATEGIC,
    EARLY_TERMINATION_CHARGES_LOAD,
    MOBILE_SERVICE_ETC_LEGACY,
    ADAPTIVE_MOBILITY_PLAN_LOAD,
    ADD_ONS_DETAILS_LOAD,
    IR_MONTH_PASS_ADD_ONS_DETAILS_LOAD,
    ACCELERATOR_ADD_ONS_DETAILS_LOAD,
    USER_MANAGEMENT_GET_USER_DYNAMIC, SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY,
    MANAGE_DIRECTORY_LISTING_LOAD,
    INTERNET_PRODUCT_DETAILS_LOAD,
    INTERNET_PRODUCT_LOAD,
    INTERNET_PRODUCT_DNS_DETAILS_LOAD,
    INTERNET_PRODUCT_DNS_LIST_LOAD
} from '../actions/action-types';

import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';
import {
    serviceRequestsSummaryReducer,
    ServiceRequestsAction as SummaryAction
} from './summary-reducer';
import {
    serviceRequestsCategoriesReducer,
    ServiceRequestsAction as RequestsCategoriesAction
} from './requests-categories-reducer';
import {
    serviceRequestsCategoriesCountReducer,
    ServiceRequestsAction as RequestsCategoriesCountAction
} from './requests-categories-count-reducer';
import {
    serviceRequestCategoryItemsReducer,
    RequestCategoryItemsAction
} from './request-category-items-reducer';
import {
    serviceRequestCategoryItemQuestionsReducer,
    RequestCategoryItemQuestionsAction
} from './request-category-item-questions-reducer';

import {
    serviceRequestCategoryWithItemQuestionsReducer,
    RequestCategoryWithItemQuestionsAction
} from './request-category-with-item-questions-reducer';

import {
    serviceRequestCategoryWithDeacQuestionsReducer,
    // RequestCategoryWithDeacQuestionsAction
} from './request-category-with-deac-questions-reducer';

import {
    createServiceRequestReducer
} from './create-request';

import {
    openRequestsReducer,
    RequestsAction as OpenRequestsAction
} from './open-requests-reducer';
import {
    closedRequestsReducer,
    RequestsAction as ClosedRequestsAction
} from './closed-requests-reducer';

import {
    serviceRequestDetailsReducer,
    ServiceRequestAction
} from './request-details-reducer';

import {
    serviceRequestActivityDetailsReducer,
    ServiceRequestActivityAction
} from './request-details-activity-reducer';

import {
    fileUploadRequestReducer,
    FileUploadRequestsAction
} from './file-upload-reducer';

import {
    serviceRequestDomesticActivitiesReducer,
    ServiceRequestActivitiesAction
} from './request-domestic-activities-reducer';

import { PatchRequestAction, patchRequestReducer } from './customer-reference';

import {
    serviceRequestCategoryWithItemsReducer
} from './requests-category-with-items-reducer';

import {
    postRequestCommentReducer,
    PostRequestCommentAction
} from './request-comment-reducer';

import {
    loadDevicesReducer,
    LoadDevicesAction
} from './load-devices';

import {
    loadDevicesSummaryReducer,
    LoadDevicesSummaryAction
} from './load-devices-summary';

import {
    loadDevicesChargeableReducer,
    LoadDevicesChargeableAction
} from './load-devices-chargeable';

import {
    loadEnrollHistoryDataReducer,
    LoadEnrollHistoryDataAction
} from './load-enroll-history-data';

import {
    loadTenancyDetailsReducer,
    LoadTenancyDetaislAction
} from './load-tenancy-details';

import {
    loadUserDetailReducer,
    LoadUserDetailAction
} from './load-user-detail';

import {
    loadDeviceDetailReducer,
    LoadDeviceDetailAction
} from './load-device-detail';
import {
    loadTopTenAppsReducer,
    LoadTopTenAppsAction
} from './top-ten-apps-list-reducer';
import {
    updateDeviceLocationSuccessReducer,
    searchDeviceMDMAction,
    searchDeviceLocationsSuccessReducer,
    updateSortLocationSuccessAction
} from './load-device-search-mdm-reducer';

import {
    UpdateCovid19RequestFlagAction,
    updateCovid19RequestFlagReducer
} from './updated-covid-request-flag-reducer';

import {
    loadMobileServicesReducer,
    LoadMobileServicesAction
} from './load-mobile-services';

import {
    loadFeatureFlagsReducer,
    LoadFeatureFlagsAction
} from './load-feature-flags'

import {
    loadFNCServiceListReducer,
    LoadFNCServiceListAction
} from './fnc-service-list-reducer'

import {
    GetUserDynamicReducer,
    GetUserDynamicAction
} from './user-dynamic-reducer'

import {
    loadUserProfileReducer,
    LoadUserProfileAction
} from './user-profile-reducer'

import {
    loadFNCRequestTypeDetailsReducer,
    LoadFNCRequestTypeDetailsAction
} from './load-fnc-request-type-details-reducer'

import {
    loadNbnServiceReducer,
    LoadNbnServiceAction,
    updateServiceListPaginationReducer,
    UpdateNbnServiceListPaginationAction,
    UpdateNbnServiceListAction,
    updateServiceListReducer
} from './load-nbn-service-list'

import {
    loadProductFamiliesReducer,
    LoadProductFamiliesAction
} from './load-product-families-reducer'

import {
    loadFNCProductCatalogueReducer,
    LoadFNCProductCatalogueAction
} from './load-fnc-product-catalogue-reducer'

import {
    loaAllRequestsReducer,
    LoadAllRequestsAction
} from './all-requests-reducer'

import {
    loaAllInternetProductReducer,
    LoadAllInternetProductRequestAction
} from './all-internet-product-reducer'

import {
    loaAllMaximRequestsReducer,
    LoadAllMaximRequestsAction
} from './all-maxim-request-reducer'
import {
    loadFNCRequestsReducer,
    LoadFNCRequestsAction
} from './load-fnc-requests-reducer'

import {
    loadNbnResultsReducer,
    LoadNbnTestResultAction
} from './load-nbn-results'

import {
    downloadAttachmentReducer,
    DownloadAttachmentAction
} from './download-attachment-reducer';

import {
    updateNbnTestMessageReducer, updateNbnResultMessageReducer, UpdateNbnTestResultAction,
    updateNbnDiagnosticResultReducer, UpdateDiagnosticResultAction,
    addToastReducer, AddToastAction, deleteToastReducer, AddResultToastAction,
    addResultToastReducer, deleteResultToastReducer, DismissResultToastAction, dismissToastReducer, AddErrorToastAction,
    addErrorToastReducer, deleteErrorToastReducer, DeleteErrorToastAction, updateNbnErrorMessageReducer
} from './update-nbn-test-result';
import { createNBNTestRequestReducer, TestRequestsAction } from './create-nbn-test';
import { loadValidateSimReducer } from './load-validate-sim'
import {
    validateFNN,
    ValidateFNNAction
} from './fnc-fnn-validation-reducer';
import { loadCompanyReducer, LoadCompanyAction } from './load-company';
import { loadNbnHistoryReducer, LoadNbnHistoryResultAction } from './load-nbn-history';
import { loadListOfAttachmentsReducer } from './load-list-of-attachments';
import { deleteFileAttachmentsReducer } from './delete-attachments';
import { loadSmServiceIdReducer, LoadSmServiceIdAction } from './load-sm-service-id';
import { loadMaximDetailsReducer, LoadMaximDetailsRequestsAction } from './load-maxim-details-reducer';

import { LoadMaximActivitiesAction, loadMaximActivitiesReducer } from './maxim-activities-reducer';
import {
    LoadStrategicDeviceDetailsAction,
    loadStrategicDeviceDetailsReducer
} from './load-strategic-device-details';
import {
    LoadDeliveryAddressAutoSearchAction,
    loadDeliveryAddressAutoSearchReducer
} from '@telstra-connect/service-requests/reducers/delivery-address-autosearch';
import {
    LoadStrategicSimConfigInfoAction,
    loadStrategicSimConfigInfoReducer
} from './load-strategic-device-sim-config-info';
import {
    LoadCustomerContactAction,
    LoadCustomerContactReducer
} from './load-customer-contact';
import { loadAddressSimplifiedReducer } from './delivery-address-simplified';
import { loadAdvancedAddressReducer } from './delivery-advanced-address';
import { loadAPNListReducer, LoadAPNListAction } from './apn-list';
import { LoadCIDNAssociatedToServiceAction, loadCIDNAssociatedToServiceReducer } from './load-cidn-associated-service';
import {
    loadNITServiceListReducer,
    LoadNITServiceListAction
} from './load-nit-service-list';
import { trackingReducer } from './set-tracking-active-tab-reducer';
import {
    loadMobileServicesListReducer,
    LoadMobileServicesListAction
} from './load-mobile-services-list';
import { loadTonSubscriptionDetailReducer } from './load-ton-subscription-detail';
import {
    updateCompanyIdReducer,
    UpdateCompanyIdAction,
} from './updated-company-id-reducer';
import {
    LoadMobileServicesDetailStrategicAction,
    loadMobileServiceDetailsReducer
} from './load-mobile-services-detail-strategic';
import {
    loadEarlyTerminationChargesDetailReducer,
    LoadEarlyTerminationChargesDetailAction
} from './load-early-termination-charges';
import {
    loadLegacyETCInfoReducer,
    LegacyETCInfoAction
} from './load-legacy-etc-reducer';
import {
    loadAdaptiveMobilityPlanDetailReducer,
    LoadAdaptiveMobilityPlanDetailAction
} from './load-adaptive-mobility-plan';
import {
    loadAddOnsDetailsReducer,
    LoadAddOnsDetailsAction
} from './load-add-ons-details-reducer';
import {
    loadIrMonthPassAddOnsDetailsReducer,
    LoadIrMonthPassAddOnsDetailsAction
} from './load-ir-month-pass-addondetails-reducer';
import {
    loadAcceleratorAddOnsDetailsReducer,
    LoadAcceleratorAddOnsDetailsAction
} from './load-accelerator-add-ons-details-reducer'
import {
    LoadServicesSummaryAction,
    loadServicesSummaryReducer
} from "@telstra-connect/service-requests/reducers/load-services-summary";
import {
    loadManageDirectoryListingReducer,
    LoadManageDirectoryListingAction
} from './load-manage-directory-listing-reducer';
import { InternetProductAction, internetProductDetailsReducer } from './internet-product-details-reducer';
import { loadInternetProductDnsDetailsReducer } from './load-internet-product-dns-details';
import { loadAllInternetProductDnsReducer } from './all-intenet-product-dns-reducer';
// import { LoadAllInternetProductAction } from '../actions/load-all-internet-products';

export type ServiceRequestsAction =
    SummaryAction
    | RequestsCategoriesAction
    | OpenRequestsAction
    | ClosedRequestsAction
    | RequestCategoryItemsAction
    | RequestCategoryItemQuestionsAction
    | RequestCategoryWithItemQuestionsAction
    | ServiceRequestAction
    | ServiceRequestActivityAction
    | FileUploadRequestsAction
    | ServiceRequestActivitiesAction
    | PostRequestCommentAction
    | PatchRequestAction
    | RequestsCategoriesCountAction
    | LoadDevicesAction
    | LoadDevicesSummaryAction
    | LoadDevicesChargeableAction
    | LoadEnrollHistoryDataAction
    | LoadTenancyDetaislAction
    | LoadDeviceDetailAction
    | LoadUserDetailAction
    | LoadTopTenAppsAction
    | searchDeviceMDMAction
    | updateSortLocationSuccessAction
    | UpdateCovid19RequestFlagAction
    | LoadMobileServicesAction
    | LoadStrategicDeviceDetailsAction
    | LoadStrategicSimConfigInfoAction
    | LoadFeatureFlagsAction
    | LoadFNCServiceListAction
    | LoadUserProfileAction
    | GetUserDynamicAction
    | LoadFNCRequestTypeDetailsAction
    | LoadNbnServiceAction
    | LoadProductFamiliesAction
    | LoadFNCProductCatalogueAction
    | TestRequestsAction
    | LoadAllRequestsAction
    | LoadAllMaximRequestsAction
    | LoadFNCRequestsAction
    | LoadNbnTestResultAction
    | UpdateNbnTestResultAction
    | UpdateDiagnosticResultAction
    | AddToastAction
    | AddResultToastAction
    | DismissResultToastAction
    | AddErrorToastAction
    | DeleteErrorToastAction
    | UpdateNbnServiceListAction
    | UpdateNbnServiceListPaginationAction
    | ValidateFNNAction
    | LoadCompanyAction
    | LoadNbnHistoryResultAction
    | FileUploadRequestsAction
    | DownloadAttachmentAction
    | LoadSmServiceIdAction
    | LoadMaximDetailsRequestsAction
    | LoadMaximActivitiesAction
    | LoadCustomerContactAction
    | LoadDeliveryAddressAutoSearchAction
    | LoadDeliveryAddressAutoSearchAction
    | LoadAPNListAction
    | LoadCIDNAssociatedToServiceAction
    | LoadNITServiceListAction
    | LoadMobileServicesListAction
    | UpdateCompanyIdAction
    | LoadMobileServicesDetailStrategicAction
    | LoadEarlyTerminationChargesDetailAction
    | LegacyETCInfoAction
    | LoadAdaptiveMobilityPlanDetailAction
    | LoadAddOnsDetailsAction
    | LoadIrMonthPassAddOnsDetailsAction
    | LoadAcceleratorAddOnsDetailsAction
    | LoadServicesSummaryAction
    | LoadManageDirectoryListingAction
    | InternetProductAction
    | LoadAllInternetProductRequestAction;

const reducersMap: IReducersMap<IServiceRequestsState> = {
    [REQUESTS_OPEN_LOAD]: openRequestsReducer,
    [REQUESTS_DEVICES_LOAD]: loadDevicesReducer,
    [REQUESTS_DEVICES_SUMMARY_LOAD]: loadDevicesSummaryReducer,
    [REQUESTS_DEVICES_CHARGEABLE_LOAD]: loadDevicesChargeableReducer,
    [ENROLL_HISTORY_DATA_LOAD]: loadEnrollHistoryDataReducer,
    [REQUESTS_CLOSED_LOAD]: closedRequestsReducer,
    [REQUESTS_SUMMARY_LOAD]: serviceRequestsSummaryReducer,
    [REQUESTS_CATEGORIES_LOAD]: serviceRequestsCategoriesReducer,
    [REQUESTS_CATEGORIES_COUNT]: serviceRequestsCategoriesCountReducer,
    [REQUEST_CATEGORY_ITEMS_LOAD]: serviceRequestCategoryItemsReducer,
    [REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD]: serviceRequestCategoryItemQuestionsReducer,
    [REQUEST_CATEGORY_WITH_ITEM_QUESTIONS_LOAD]: serviceRequestCategoryWithItemQuestionsReducer,
    [REQUEST_CATEGORY_WITH_DEAC_QUESTIONS_LOAD]: serviceRequestCategoryWithDeacQuestionsReducer,
    [REQUESTS_CREATE]: createServiceRequestReducer,
    [REQUEST_DETAILS_LOAD]: serviceRequestDetailsReducer,
    [REQUEST_ACTIVITY_DETAILS_LOAD]: serviceRequestActivityDetailsReducer,
    [REQUESTS_FILE_UPLOAD]: fileUploadRequestReducer,
    [REQUEST_DOMESTIC_ACTIVITIES_LOAD]: serviceRequestDomesticActivitiesReducer,
    [REQUESTS_ADD_COMMENT]: postRequestCommentReducer,
    [REQUESTS_CUSTOMER_REFERENCE]: patchRequestReducer,
    [REQUEST_CATEGORY_WITH_ITEMS_LOAD]: serviceRequestCategoryWithItemsReducer,
    [REQUESTS_TENANCY_DETAILS_LOAD]: loadTenancyDetailsReducer,
    [REQUESTS_DEVICE_DETAIL_LOAD]: loadDeviceDetailReducer,
    [REQUESTS_USER_DETAIL_LOAD]: loadUserDetailReducer,
    [MDM_LOAD_TOPTENAPPS]: loadTopTenAppsReducer,
    [MDM_UPDATE_SEARCH_LOCATIONS]: updateDeviceLocationSuccessReducer,
    [MDM_SEARCH_LOCATIONS]: searchDeviceLocationsSuccessReducer,
    [UPDATE_COVID19_REQUEST_FLAG]: updateCovid19RequestFlagReducer,
    [REQUEST_MOBILE_SERVICES]: loadMobileServicesReducer,
    [REQUEST_STRATEGIC_DEVICE_DETAILS]: loadStrategicDeviceDetailsReducer,
    [REQUEST_STRATEGIC_SIM_CONFIG_INFO]: loadStrategicSimConfigInfoReducer,
    [REQUEST_FEATURE_FLAGS]: loadFeatureFlagsReducer,
    [FEATURE_NETWORK_CHANGE_SERVICE_LIST]: loadFNCServiceListReducer,
    [USER_MANAGEMENT_GET_USER_DYNAMIC]: GetUserDynamicReducer,
    [SERVICE_REQUEST_FETCH_USER_PROFILE]: loadUserProfileReducer,
    [FEATURE_NETWORK_CHANGE_REQUEST_TYPE_DETAILS]: loadFNCRequestTypeDetailsReducer,
    [NBN_SERVICE_LIST]: loadNbnServiceReducer,
    [REQUEST_PRODUCT_FAMILIES]: loadProductFamiliesReducer,
    [FEATURE_NETWORK_CHANGE_PRODUCT_CATALOGUE]: loadFNCProductCatalogueReducer,
    [NBN_TESTS_CREATE]: createNBNTestRequestReducer,
    [REQUESTS_ALL_LOAD]: loaAllRequestsReducer,
    [MAXIM_REQUESTS_ALL_LOAD]: loaAllMaximRequestsReducer,
    [FEATURE_NETWORK_CHANGE_REQUESTS]: loadFNCRequestsReducer,
    [NBN_TESTS_POLL]: loadNbnResultsReducer,
    [NBN_UPDATE_TEST_RESULT]: updateNbnTestMessageReducer,
    [NBN_UPDATE_RESULT]: updateNbnResultMessageReducer,
    [NBN_UPDATE_DIAGNOSTIC_RESULT]: updateNbnDiagnosticResultReducer,
    [NBN_UPDATE_DIAGNOSTIC_ERROR]: updateNbnErrorMessageReducer,
    [NBN_ADD_TOAST]: addToastReducer,
    [NBN_DELETE_TOAST]: deleteToastReducer,
    [NBN_ADD_RESULT_TOAST]: addResultToastReducer,
    [NBN_DELETE_RESULT_TOAST]: deleteResultToastReducer,
    [NBN_DISMISS_RESULT_TOAST]: dismissToastReducer,
    [NBN_ADD_ERROR_TOAST]: addErrorToastReducer,
    [NBN_DELETE_ERROR_TOAST]: deleteErrorToastReducer,
    [VALIDATE_SIM_LOAD]: loadValidateSimReducer,
    [NBN_UPDATE_SERVICE_LIST]: updateServiceListReducer,
    [NBN_UPDATE_SERVICE_LIST_PAGINATION]: updateServiceListPaginationReducer,
    [FEATURE_NETWORK_CHANGE_FNN_VALIDATION]: validateFNN,
    [REQUESTS_LOAD_COMPANY]: loadCompanyReducer,
    [NBN_HISTORY_DETAIL]: loadNbnHistoryReducer,
    [LIST_OF_ATTACHMENTS]: loadListOfAttachmentsReducer,
    [DELETE_FILE_ATTACHMENTS]: deleteFileAttachmentsReducer,
    [DOWNLOAD_FILE_ATTACHMENT]: downloadAttachmentReducer,
    [REQUESTS_LOAD_SM_SERVICE_ID]: loadSmServiceIdReducer,
    [MAXIM_REQUEST_DETAILS]: loadMaximDetailsReducer,
    [LOAD_MAXIM_ACTIVITIES]: loadMaximActivitiesReducer,
    [REQUESTS_CUSTOMER_CONTACT_LOAD]: LoadCustomerContactReducer,
    [DELIVERY_ADDRESS_AUTO_SEARCH_LIST]: loadDeliveryAddressAutoSearchReducer,
    [ADDRESS_SIMPLIFIED_LIST]: loadAddressSimplifiedReducer,
    [ADVANCED_ADDRESS_LIST]: loadAdvancedAddressReducer,
    [APN_LIST]: loadAPNListReducer,
    [CIDN_ASSOCIATED_SERVICE]: loadCIDNAssociatedToServiceReducer,
    [REQUEST_NIT_SERVICE_FLAG]: loadNITServiceListReducer,
    [SET_TRACKING_ACTIVE_TAB]: trackingReducer,
    [MOBILE_SERVICES_LIST]: loadMobileServicesListReducer,
    [TON_SUBSCRIPTION_DETAILS_LOAD]: loadTonSubscriptionDetailReducer,
    [UPDATE_COMPANY_ID]: updateCompanyIdReducer,
    [MOBILE_SERVICES_DETAIL_STRATEGIC]: loadMobileServiceDetailsReducer,
    [EARLY_TERMINATION_CHARGES_LOAD]: loadEarlyTerminationChargesDetailReducer,
    [MOBILE_SERVICE_ETC_LEGACY]: loadLegacyETCInfoReducer,
    [ADAPTIVE_MOBILITY_PLAN_LOAD]: loadAdaptiveMobilityPlanDetailReducer,
    [ADD_ONS_DETAILS_LOAD]: loadAddOnsDetailsReducer,
    [IR_MONTH_PASS_ADD_ONS_DETAILS_LOAD]: loadIrMonthPassAddOnsDetailsReducer,
    [ACCELERATOR_ADD_ONS_DETAILS_LOAD]: loadAcceleratorAddOnsDetailsReducer,
    [SERVICE_PERFORMANCE_LOAD_SERVICES_SUMMARY]: loadServicesSummaryReducer,
    [MANAGE_DIRECTORY_LISTING_LOAD]: loadManageDirectoryListingReducer,
    [INTERNET_PRODUCT_DETAILS_LOAD]: internetProductDetailsReducer,
    [INTERNET_PRODUCT_LOAD]: loaAllInternetProductReducer,
    [INTERNET_PRODUCT_DNS_DETAILS_LOAD]: loadInternetProductDnsDetailsReducer,
    [INTERNET_PRODUCT_DNS_LIST_LOAD]: loadAllInternetProductDnsReducer,
};

export const reducers = reducer<IServiceRequestsState, ServiceRequestsAction>(reducersMap, initialState);
